module.exports = __webpack_public_path__ + "static/media/ic_azupay.ad9722ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_azupay.svg
// module id = 287
// module chunks = 0